let config = {};
let data = {};

export default {
	init(conf) {
		config = conf;
	},
	get(key) {
		if (!data[key]) {
			data[key] = config[key]();
		}
		return data[key];
	},
	del(key) {
		delete data[key];
	}
}